import { Directory } from "../pages/useraccount/directory/directory";


const CATEGORY = ['Employee', 'Contractor'];

const ROLE = ['Employee', 'Project Manager', 'Lead manager'];



interface Field {
  title: string;
  // name: keyof UserRole; // Use keyof UserRole to ensure type safety
  name: string;
  type: string;
  width: number;
  height?: number;
  isRequired: boolean;
  options?: string[]; // Options will be set dynamically based on the field name
}

export const DirectoryFields: Field[] = [
  {
    title: "Employee ID",
    name: "userid",
    type: "text",
    width: 450,
    height: 70,
    isRequired: false,
  },
  {
    title: "Employee Name",
    name: "username",
    type: "text",
    width: 450,
    isRequired: false,
    
  },
  {
    title: "Organization",
    name: "organization",
    type: "text",
    height: 70,
    width: 350,
    isRequired: false,
  },
  {
    title: "Email",
    name: "email",
    type: "text",
    width: 450,
    isRequired: false,
    // options: ACCESS_CHOICES, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Password",
    name: "password",
    type: "text",
    width: 450,
    isRequired: false,
   
  },
  {
    title: "Created Date",
    name: "createdon",
    type: "date",
    width: 450,
    isRequired: false,
   
  },
  {
    title: "Category",
    name: "category",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: CATEGORY, // Use ACCESS_CHOICES defined above
  },
 
  {
    title: "Role",
    name: "role",
    type: "dropDown",
    width: 450,
    isRequired: false,
    options: ROLE, // Use ACCESS_CHOICES defined above
  },
  {
    title: "Title",
    name: "title",
    type: "text",
    width: 450,
    isRequired: false,
    
  },
];
